import { render, staticRenderFns } from "./MyRefundList2.vue?vue&type=template&id=668bbb4b&scoped=true&"
import script from "./MyRefundList2.vue?vue&type=script&lang=js&"
export * from "./MyRefundList2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668bbb4b",
  null
  
)

export default component.exports